__webpack_require__.O(0, ["onfidoAuth"], function() {
	__webpack_require__.E("activeVideo");
}, 5);